import type { PreloadedEntryPoint } from 'react-relay';
import { QueryPromisesMap } from '@atlassian/relay-query-promises';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type { AnyEntryPoint } from '@jira/platform__entry-point/src/common/types.tsx';

export type EntrypointStatEntry = {
	queryId: string;
	status: 'resolved' | 'rejected' | 'pending';
	// TODO: expose extra information like
	// timeStart: Date;
	// timeEnd: Date;
};

/**
 * @deprecated a test helper to create a promise that resolves in a timeout without violating testing/no-timeout-in-tests eslint rule
 */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const testGetTimedPromise = (): Promise<any> =>
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	new Promise<any>((resolve) => setTimeout(resolve, 0));

export const getPromiseState = async (
	promise: Promise<unknown> | undefined,
): Promise<'resolved' | 'rejected' | 'pending'> => {
	if (!promise) {
		return 'resolved';
	}
	try {
		if ((await Promise.race([promise, Promise.resolve('timeout')])) === 'timeout') {
			return 'pending';
		}
		return 'resolved';
	} catch (e) {
		return 'rejected';
	}
};

const getEntrypointQueryState = async (queryId: string): Promise<EntrypointStatEntry> => {
	const queryPromise = QueryPromisesMap.get(queryId);
	return { queryId, status: await getPromiseState(queryPromise) };
};

export const getEntryPointStats = <TEntryPoint extends AnyEntryPoint>(
	entryPointConfig: PreloadedEntryPoint<TEntryPoint>,
): Promise<ReadonlyArray<EntrypointStatEntry>> => {
	const result: Array<Promise<EntrypointStatEntry>> = [];

	const analyseEntrypoint = ({
		queries,
		entryPoints,
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	}: Readonly<PreloadedEntryPoint<any>>) => {
		if (queries) {
			Object.keys(queries).forEach((key) => {
				if (queries[key].id) {
					result.push(getEntrypointQueryState(String(queries[key].id)));
				}
			});
		}

		if (entryPoints) {
			Object.entries(entryPoints).forEach(([, entryPoint]) => {
				analyseEntrypoint(entryPoint);
			});
		}
	};
	analyseEntrypoint(entryPointConfig);

	return Promise.all(result);
};
